import useFunctionInfo from "@/Hooks/useDataInformation/useFunctionInfo";
import type { MCategories } from "@/Models/DepartamentCategory/DepartamentCategory";
import type { CategoriesV2 } from "@/Models/MListCategories/Categories";
import { useEffect, useState } from "react";

export const useDepartamentCategorie = () => {
  const { data: fetchedList, loading: isLoadings } =
    useFunctionInfo<MCategories[]>("/Departamentos");

  //state
  const [departamentData, setDepartamentData] = useState<MCategories[]>([]);
  const [isLogin, setIsLogin] = useState<boolean>(true);

  useEffect(() => {
    //si no existe nada en memoria.
    if (!isLoadings) {
      setDepartamentData(fetchedList ?? []);
      setIsLogin(false);
    }
  }, [isLoadings, fetchedList]);

  return {
    departamentData,
    isLoading: isLoadings || isLogin,
  };
};

//==================================================
const STORAGE_KEY = "FooterDataCache";
const CACHE_TTL = 60 * 60 * 1000; // 1 hora en milisegundos

type CacheItem<T> = {
  data: T;
  timestamp: number;
};

//==================================================
export const useFooterInfo = () => {
  //lista de sub-categoria por categoria
  const [listFooter, setListFooter] = useState<CategoriesV2[]>([]);
  //cargando el skeleton
  const [isLoadingFooter, setIsLoadingFooter] = useState<boolean>(true);
  //llamamos a la funcion para obtener las sub-categorias
  const { data: footerInfo, loading: isLoadings } =
    useFunctionInfo<CategoriesV2[]>(`/Footer`);

  //reacciona cuando cambia la data o el loading
  useEffect(() => {
    const storedItem = localStorage.getItem(STORAGE_KEY);
    if (storedItem) {
      const parsed = JSON.parse(storedItem) as CacheItem<CategoriesV2[]>;
      const isExpired = Date.now() - parsed.timestamp > CACHE_TTL;
      parsed.data;
      setListFooter(parsed.data);
      setIsLoadingFooter(false);
    } else {
      const footerInfoLength = Array.isArray(footerInfo)
        ? footerInfo.length
        : 0;
      const footerInfooData = Array.isArray(footerInfo) ? footerInfo : [];
      if (!isLoadings && footerInfoLength) {
        setListFooter(footerInfooData);
        setIsLoadingFooter(isLoadings);
      }
    }
  }, [footerInfo, isLoadings]);

  return {
    listFooter,
    isLoadingFooter,
  };
};
